import React from "react";

const LoginBg = ({ children, className }) => {
  return (
    <div
      className={`w-full
        gradient-bg
        gradient-border
        backdrop-blur-[5px] 
        `}
    >
      {children}
    </div>
  );
};

export default LoginBg;
